export const ACTION_IMAGE_REFRESH_QUERY_OPTIONS = {
    refetchInterval: 40 * 60 * 1000,
    refetchIntervalInBackground: true,
} as const;
